var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 16,
    viewBox: "0 0 15.5 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-regular-file-pdf",
    "data-name": "Icon fa-regular-file-pdf",
    d: "M2,14.5H3V16H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H7.172A2,2,0,0,1,8.587.584l2.828,2.828A2,2,0,0,1,12,4.828V9H10.5V5H8A1,1,0,0,1,7,4V1.5H2a.5.5,0,0,0-.5.5V14A.5.5,0,0,0,2,14.5ZM5.5,11h1a1.75,1.75,0,0,1,0,3.5H6v1a.5.5,0,0,1-1,0v-4A.5.5,0,0,1,5.5,11Zm1,2.5a.75.75,0,0,0,0-1.5H6v1.5Zm3-2.5h1A1.5,1.5,0,0,1,12,12.5v2A1.5,1.5,0,0,1,10.5,16h-1a.5.5,0,0,1-.5-.5v-4A.5.5,0,0,1,9.5,11Zm1,4a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5H10v3ZM13,11.5a.5.5,0,0,1,.5-.5H15a.5.5,0,0,1,0,1H14v1h1a.5.5,0,0,1,0,1H14v1.5a.5.5,0,0,1-1,0Z",
    fill: "#027bc6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.367f8553b350e6ba7a036bce4480c051.svg";
export { ForwardRef as ReactComponent };